import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  Input
} from '@angular/core';
import confetti, { Shape } from 'canvas-confetti';
import { colors } from '@design-system/styles/colors';

// Types
import type { ConfettiConfig } from './m-confetti.component.types';

/**
 * Component to display confetti animation.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-confetti',
  templateUrl: './m-confetti.component.html'
})
export class MConfettiComponent implements AfterViewInit, ConfettiConfig {
  // Delay before the confetti animation starts (ms). Default is 0.
  @Input() delay = 0;
  // Duration of the confetti animation (ms). Default is 1000.
  @Input() duration = 1000;
  // Array of colors for the confetti. Default is orange and yellow.
  @Input() colorsArray: string[] = [
    String(colors['orange-400']),
    String(colors['yellow-400'])
  ];

  // Array of shapes for the confetti. Default is circle, square, and star.
  @Input() shapesArray: Shape[] = ['circle', 'square', 'star'];
  // Number of confetti particles. Default is 3.
  @Input() particleCount = 3;
  // Angle of the confetti launch. Default is 90 degrees.
  @Input() angle = 90;
  // Spread of the confetti. Default is 45.
  @Input() spread = 45;
  // Starting velocity of the confetti. Default is 45.
  @Input() startVelocity = 80;
  // Scalar value for particle sizes. Default is 1.
  @Input() scalar = 1;
  // Gravity effect on particles. Default is 1.
  @Input() gravity = 1;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.launchConfetti();
    }, this.delay);
  }

  private launchConfetti(): void {
    const end = Date.now() + this.duration;

    const frame = () => {
      confetti({
        particleCount: this.particleCount,
        angle: this.angle,
        spread: this.spread,
        startVelocity: this.startVelocity,
        origin: { x: 0, y: 1 },
        colors: this.colorsArray,
        shapes: this.shapesArray,
        scalar: this.scalar,
        gravity: this.gravity
      });

      confetti({
        particleCount: this.particleCount,
        angle: this.angle,
        spread: this.spread,
        startVelocity: this.startVelocity,
        origin: { x: 1, y: 1 },
        colors: this.colorsArray,
        shapes: this.shapesArray,
        scalar: this.scalar,
        gravity: this.gravity
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
  }
}
